import { createSelector } from 'reselect';
import { ITrackingLine } from '../../../models';
import { IRootState } from '../../state';

export const getTrackingLines = createSelector(
  [(state: IRootState) => state],
  (state: IRootState): Array<ITrackingLine> => {
    return state.trackingLine.trackingLineList || [];
  }
);